(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

/*
CSS Browser Selector js v0.5.3 (July 2, 2013)

-- original --
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
  License: http://creativecommons.org/licenses/by/2.5/
    Contributors: http://rafael.adm.br/css_browser_selector#contributors
      -- /original --

Fork project: http://code.google.com/p/css-browser-selector/
  Song Hyo-Jin (shj at xenosi.de)
*/
function css_browser_selector(u) {
  var ua = u.toLowerCase(),
      is = function is(t) {
    return ua.indexOf(t) > -1;
  },
      g = 'gecko',
      w = 'webkit',
      s = 'safari',
      c = 'chrome',
      o = 'opera',
      m = 'mobile',
      v = 0,
      r = window.devicePixelRatio ? (window.devicePixelRatio + '').replace('.', '_') : '1';
  var res = [
  /* IE */
  !/opera|webtv/.test(ua) && /msie\s(\d+)/.test(ua) && (v = RegExp.$1 * 1) ? 'ie ie' + v + (v == 6 || v == 7 ? ' ie67 ie678 ie6789' : v == 8 ? ' ie678 ie6789' : v == 9 ? ' ie6789 ie9m' : v > 9 ? ' ie9m' : '') :
  /* IE 11 */
  /trident\/\d+.*?;\s*rv:(\d+)\.(\d+)\)/.test(ua) && (v = [RegExp.$1, RegExp.$2]) ? 'ie ie' + v[0] + ' ie' + v[0] + '_' + v[1] + ' ie9m' :
  /* FF */
  /firefox\/(\d+)\.(\d+)/.test(ua) && (re = RegExp) ? g + ' firefox firefox' + re.$1 + ' firefox' + re.$1 + '_' + re.$2 : is('gecko/') ? g :
  /* Opera */
  is(o) ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 : /opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '') :
  /* K */
  is('konqueror') ? 'konqueror' :
  /* Black Berry */
  is('blackberry') ? m + ' blackberry' :
  /* Chrome */
  is(c) || is('crios') ? w + ' ' + c :
  /* Iron */
  is('iron') ? w + ' iron' :
  /* Safari */
  !is('cpu os') && is('applewebkit/') ? w + ' ' + s :
  /* Mozilla */
  is('mozilla/') ? g : '',
  /* Android */
  is('android') ? m + ' android' : '',
  /* Tablet */
  is('tablet') ? 'tablet' : '',
  /* Machine */
  is('j2me') ? m + ' j2me' : is('ipad; u; cpu os') ? m + ' chrome android tablet' : is('ipad;u;cpu os') ? m + ' chromedef android tablet' : is('iphone') ? m + ' ios iphone' : is('ipod') ? m + ' ios ipod' : is('ipad') ? m + ' ios ipad tablet' : is('mac') ? 'mac' : is('darwin') ? 'mac' : is('webtv') ? 'webtv' : is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') : is('freebsd') ? 'freebsd' : is('x11') || is('linux') ? 'linux' : '',
  /* Ratio (Retina) */
  r != '1' ? ' retina ratio' + r : '', 'js portrait'].join(' ');
  if (window.jQuery && !window.jQuery.browser) {
    window.jQuery.browser = v ? { msie: 1, version: v } : {};
  }
  document.documentElement.className += ' ' + res;
};
css_browser_selector(navigator.userAgent);

$(document).ready(function () {

  $('[data-mask]').each(function () {
    var type = $(this).data('mask');
    switch (type) {
      case "phone":
        $(this).inputmask({
          mask: "0*-999-99-99",
          showMaskOnHover: false,
          definitions: {
            '9': {
              validator: "[0-9]",
              cardinality: 1,
              casing: "lower"
            },
            '*': {
              validator: "(50|51|55|60|70|77|10)",
              cardinality: 2
            }
          }
        });
        break;
      case "number":
      case "decimal":
      case "integer":
        $(this).inputmask(type, { rightAlign: false });
        break;
    }
  });

  var media = window.matchMedia("(max-width: 991px)");
  mobileSupport(media);
  media.addListener(mobileSupport);

  $('.form input,.form textarea').focus(function () {
    $(this).addClass('active');
  }).blur(function () {
    if ($(this).val() == "") $(this).removeClass('active');
  });

  $('.about,.form').matchHeight();
});

$.is_mobile = false;
var mobileSupport = function mobileSupport(media) {
  if (media.matches) {
    $.is_mobile = true;
    $(".gallery .items").addClass('owl-carousel').owlCarousel({
      margin: 10,
      responsiveClass: true,
      nav: true,
      dots: false,
      navText: ['', ''],
      responsive: {
        0: {
          items: 2
        }
      }
    });
  } else {
    $.is_mobile = false;
  }
};

},{}]},{},[1]);
